import * as ErrorCodes from './validationErrorCodes';

	/*--------------------------------------------------
		Exposed function - Stock Order Save Validation
		Fields:
			sRefNum				- string	- Order Reference Number
			bIsSubmit			- boolean	- true if submitting
			iInventoryPK		- int		- Inventory PK
			iReferenceMinLength	- int		- Reference Number Minimum Length
			iReferenceMaxLength	- int		- Reference Number Maximum Length
			sReferenceMask		- string	- Reference Number Mask e.g. xxxxS
	--------------------------------------------------*/
	export async function stockOrderSaveValidation(arg) {
		return _validateOrderReference(arg);
	}

	/*--------------------------------------------------
		Exposed function - Order Reference Validation
		Fields:
			sRefNum				- string	- Order Reference Number
			bIsSubmit			- boolean	- true if submitting
			iInventoryPK		- int		- Inventory PK
			iReferenceMinLength	- int		- Reference Number Minimum Length
			iReferenceMaxLength	- int		- Reference Number Maximum Length
			sReferenceMask		- string	- Reference Number Mask e.g. xxxxS
	--------------------------------------------------*/
	export async function validateOrderReferenceNumber(arg) {
		/*
			Only validate on submit
		*/
		if (!arg.bIsSubmit && arg.sRefNum === "") return _success();
		return _validateOrderReference(arg);
	}

		function _validateOrderReference(arg){
			let result;
			if (!arg.sRefNum) return _error(ErrorCodes.RC_ORDER_REFERENCE_BLANK);
			result = _isReferenceNumValid(arg);
			if (result.errorCode !== 0) return result;
			result = _isReferenceNumValidLength(arg);
			if (result.errorCode !== 0) return result;
			result = _isReferenceNumValidFormat(arg);
			if (result.errorCode !== 0) return result;
			return _isReferenceNumDuplicate(arg);
		}

		function _isReferenceNumValid(arg){
			if (!_lettersAndNumbersOnly(arg.sRefNum)) return _error(ErrorCodes.RC_ORDER_REFERENCE_INVALID);
			return _success();
		}

		function _isReferenceNumValidLength(arg) {
			let errorCode = ErrorCodes.RC_ORDER_REFERENCE_LENGTH;
			if (arg.iReferenceMinLength && arg.iReferenceMaxLength &&
				arg.iReferenceMinLength > 0 && arg.iReferenceMaxLength > 0 &&
				(arg.sRefNum.length < arg.iReferenceMinLength || arg.sRefNum.length > arg.iReferenceMaxLength))
				return _error(errorCode);
			if (arg.iReferenceMinLength && arg.iReferenceMinLength > 0 && arg.sRefNum.length < arg.iReferenceMinLength)
				return _error(errorCode);
			if (arg.iReferenceMaxLength && arg.iReferenceMaxLength > 0 && arg.sRefNum.length > arg.iReferenceMaxLength)
				return _error(errorCode);
			return _success();
		}

		function _isReferenceNumValidFormat(arg){
			let match = true;
			if (arg.sReferenceMask !== null) {
				if (arg.sRefNum.length !== arg.sReferenceMask.length) {
					match = false;
				}
				else {
					for (let i = 0; i < arg.sReferenceMask.length; i++) {
						if (arg.sReferenceMask[i] !== "x" && arg.sRefNum[i] !== arg.sReferenceMask[i]) {
							match = false;
							break;
						}
					}
				}
			}
			if (!match) return _error(ErrorCodes.RC_ORDER_REFERENCE_FORMAT);
			return _success();
		}

		async function _isReferenceNumDuplicate(arg) {
			return fetch('api/StockOrder/CheckValidReferenceNumber/' + arg.iInventoryPK + '/' + arg.sRefNum, {
				method: 'GET',
				headers: { 'Content-Type': 'application/json' }
			})
				.then(response => response.json())
				.then(data => {
					if (!data.isValidReferenceNumber) return _error(ErrorCodes.RC_ORDER_REFERENCE_DUP);
					else return _success();
				})
				.catch((error) => {
					console.log(error);
					return _error(ErrorCodes.RC_ORDER_REFERENCE_DUP);
				});
		}

	/*--------------------------------------------------
		Exposed function - Duplicate Order
		Fields:
			sRefNum - string - Order Reference Number
	--------------------------------------------------*/
	export function isDuplicateOrder(arg){
		return _success();
	}

	/*--------------------------------------------------
		Exposed function - Clear/Cancel Stock Order
		Fields:
			sRefNum - string - Order Reference Number
	--------------------------------------------------*/
	export function clearCancelStockOrder(arg){
		return _error(10); //, "Are you sure you want to mark this order as cancelled?");
	}

	/*--------------------------------------------------
		Exposed function - OEM Cut-Off Time
		Fields:
			iInventoryPK	- int - Inventory PK
			iOrderPK		- int - Order PK
	--------------------------------------------------*/
	export function isOEMCutoffTime(arg){
		return _success();
	}

	/*--------------------------------------------------
		Exposed function - Minimum Order Quantity Notification
		Fields:
			sRefNum - string - Order Reference Number
	--------------------------------------------------*/
	export function MinimumOrderQuantityCheck(arg){
		return false;
	}

	/*--------------------------------------------------
		Exposed function - Unusual Order Notification
		Fields:
			sRefNum - string - Order Reference Number
	--------------------------------------------------*/
	export function UnusualOrderCheck(arg){
		return _success();
	}

	/*--------------------------------------------------
		Exposed function - OEM Order Types
		Fields:
			sRefNum - string - Order Reference Number
	--------------------------------------------------*/
	export function oemOrderTypes(arg){
		return "";
	}
	
	/*--------------------------------------------------
		Exposed function - Bin Validation
		Fields:
			sBin - string - Bin Location
	--------------------------------------------------*/
	export function validateBin(arg) {
		// No bin, no need to validate
		if (arg.bin) {
			let invalidCharacters = _lettersAndNumbersOnly(arg.sBin);
			if (invalidCharacters) {
				return _error(ErrorCodes.RC_BIN, invalidCharacters);
			}
		}
		return _success();
	}
	
	/*--------------------------------------------------
		Exposed function - Quantity Validation
		Fields:
			sQuantity			- string	- Quantity
			iQuantityMinOrder	- int		- Quantity Min Order
			iMaxOrderQuantity	- int		- Max Order Quantity
			iMaxStockLevel		- int		- Pack Quantity
			iQuantityOnHandSS	- int		- Pack Quantity
			iQuantityOnOrderSS	- int		- Pack Quantity
			iStockMax			- int		- Pack Quantity
			iQuantityOnHand		- int		- Pack Quantity
			iQuantityOnOrder	- int		- Pack Quantity
			iPackQuantity		- int		- Pack Quantity
			bOver50Ok			- boolean	- Over 50 flag - true if the user has been notified and accepted
	--------------------------------------------------*/
	export function validateQuantity(arg){
		return _validateQuantity(arg);
	}

		function _validateQuantity(arg){
			let result;
			result = _isQuantityValid(arg);
			if (result) return result;
			result = _isMinimumOrderQuantity(arg);
			if (result) return result;
			result = _isMinimumOrderableQuantity(arg);
			if (result) return result;
			result = _isMinimumOrderRequirement(arg);
			if (result) return result;
			result = _isMaximumOrderQuantity(arg);
			if (result) return result;
			result = _isMaximumStockingLevel(arg);
			if (result) return result;
			result = _isStockMax(arg);
			if (result) return result;
			result = _isPackQuantity(arg);
			if (result) return result;
			return _isOrdering50Plus(arg);
		}

		function _isQuantityValid(arg){
			if (!_numbersOnly(arg.sQuantity)) return _error(ErrorCodes.RC_QUANTITY_INVALID_CHARACTERS);
			if (parseInt(arg.sQuantity) === 0) return _error(ErrorCodes.RC_QUANTITY_ZERO);
			return _success();
		}

		function _isMinimumOrderQuantity(arg) {
			// Quantity entered must meet the minimum orderable quantity (quantityMinOrder) set at the Inventory Level (aka - Manual Stocking Min)
			if (arg.iQuantityMinOrder && parseInt(arg.sQuantity) < arg.iQuantityMinOrder) return _error(ErrorCodes.RC_QUANTITY_MIN_ORDERABLE);
			return _success();
		}

		function _isMaximumOrderQuantity(arg) {
			// Checks whether the quantity entered (maxOrderQuantity) meets the maximum order requirement set by the OEM for a given part. 
			if (arg.iMaxOrderQuantity && parseInt(arg.sQuantity) > arg.iMaxOrderQuantity) return _error(ErrorCodes.RC_QUANTITY_MAX_ORDER);
			return _success();
		}

		function _isMaximumStockingLevel(arg) {
			// Checks if maxStockLevel is greater than 0 and (maxStockLevel - (quantityOnHandSS + quantityOnOrderSS)) is less than the current quantity.  
			// This set by the OEM and applies to all parts within a Supersession chain.
			if (arg.iMaxStockLevel && arg.maxStockLevel > 0 &&
				(arg.iMaxStockLevel - (arg.iQuantityOnHandSS + arg.iQuantityOnOrderSS)) < parseInt(arg.sQuantity)) return ErrorCodes.RC_QUANTITY_MAX_STOCKING_LEVEL;
			return _success();
		}

		function _isStockMax(arg) {
			// Checks if quantity is at or above the calculated Stock Max (Inventory Level) and (Stock Max > (Quantity on Hand + Quantity On Order))
			if (arg.iStockMax && arg.iStockMax > 0 &&
				(parseInt(arg.sQuantity) >= arg.iStockMax && (arg.iStockMax > (arg.iQuantityOnHand + arg.iQuantityOnOrder)))) return ErrorCodes.RC_QUANTITY_STOCK_MAX;
			return _success();
		}

		function _isPackQuantity(arg){
			if (parseInt(arg.sQuantity) % arg.iPackQuantity !== 0) return _error(ErrorCodes.RC_QUANTITY_PACK);
			return _success();
		}

		function _isOrdering50Plus(arg){
			if (arg.bOver50Ok) return _success();
			if (parseInt(arg.sQuantity) > 49) return _error(ErrorCodes.RC_QUANTITY_ADDING_50_PLUS);
			return _success();
		}

	/*--------------------------------------------------
		Shared internal functions
	--------------------------------------------------*/
	function _success() {
		return _error(ErrorCodes.RC_SUCCESS);
	}

	function _error(code, reason) {
		return { result: code, reason: reason };
	}

function _lettersAndNumbersOnly(str) {
		return str.match(/[^a-z0-9 -]/ig);
	}

	function _numbersOnly(str) {
		return str.match(/^[0-9]+$/);
	}
